<div class="mx-4 flex items-center justify-between border-b border-background-disabled pb-4 pt-[2px]">
  <div class="flex h-[28px] items-center gap-1">
    <button class="flex items-center p-[6px]" (click)="onCollapseClick()">
      @if (isCollapsed) {
        <svg-icon key="px-16-arrow-left" size="sm" class="-mt-[2px] text-primary-blue"></svg-icon>
      } @else {
        <svg-icon key="px-16-arrow-right" size="sm" class="-mt-[2px] text-primary-blue"></svg-icon>
      }
    </button>
    @if (!isCollapsed) {
      <div class="typo-h3-light" [style.opacity]="opacity === 1 ? opacity : opacity / 4">
        {{ 'charting_details_images_title' | translate }}
      </div>
    }
  </div>
</div>

<div
  class="h-100 flex h-full flex-col gap-5 overflow-auto px-4 pb-[80px]"
  [style.opacity]="opacity"
  [style.minWidth.px]="isCollapsed ? 60 : 184"
>
  @if (isCollapsed) {
    <div class="flex h-[calc(100%-8px)] items-center justify-center">
      <span class="typo-h3-light -rotate-90">{{ 'charting_details_images_title' | translate }}</span>
    </div>
  } @else {
    @if (hasImagingSoftware.state === DataState.Loading || images.state === DataState.Loading) {
      <ng-lottie currentColor class="mx-auto my-5 w-5 text-primary-blue" [options]="lottieOptions"></ng-lottie>
    } @else {
      @if (hasImagingSoftware.data) {
        @for (imageGroup of images.data; track imageGroup.group) {
          <div class="flex flex-col">
            <p class="typo-h4-semibold">{{ imageGroup.group | translate }}</p>

            <lib-imaging-gallery
              class="flex gap-2 overflow-x-auto overflow-y-hidden"
              [images]="imageGroup.images"
              [patientId]="patientId"
              (imageClick)="onNavigationClick($event)"
            />
          </div>
        } @empty {
          <div class="flex h-full w-full flex-col items-center justify-center gap-4">
            <div class="flex items-center justify-center rounded-full bg-background-light-grey p-4">
              <svg-icon [key]="'px-24-image'" class="text-text-light" />
            </div>
            <div class="typo-h4-light text-text-light">{{ 'charting_details_images_empty_title' | translate }}</div>
          </div>
        }
      } @else {
        <div class="flex h-full flex-col items-center justify-center text-text-light">
          <div class="empty-state-border-radius mb-4 flex h-14 w-14 items-center justify-center bg-text-extra-light">
            <svg-icon [key]="'px-24-image'" class="" />
          </div>
          <span class="typo-h5-book">{{ 'charting_details_dexis_not_available_title' | translate }}</span>
        </div>
      }
    }
  }
</div>

<div class="absolute bottom-0 left-0 right-0 z-[60] h-[80px] rounded-b-[32px] bg-gradient-to-t from-background-white to-transparent"></div>
